import {remove} from 'lodash';
import {
  CleanModuleSetting,
  CleanModuleSettingName,
  PCleanStorageModule,
  SerializedCleanModuleSetting,
} from '../interfaces';
import {findIndex} from 'lodash';
import enumsModule, {transformFromModuleTypeStr} from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';
import {PModuleType} from '@/enums/configs';

/*
  Хранилище для настроек модуля очистки данных
*/

export class CleanModuleSettingsStore {
  private parent: PCleanStorageModule;
  private settingName: CleanModuleSettingName;
  private settings: CleanModuleSetting[] = [];

  constructor(parent: PCleanStorageModule, settingName: CleanModuleSettingName) {
    this.parent = parent;
    this.settingName = settingName;
  }

  async fetchAll() {
    if (this.parent[this.settingName]) {
      // получаем все типы ивентов
      const eventTypes = await httpClient.get<{type: string; description: string}[]>(
        `modules/events/types/`,
      );
      const strPars = JSON.parse(this.parent[this.settingName]);
      this.settings = Array.isArray(strPars)
        ? (strPars as SerializedCleanModuleSetting[]).map((setting, index) => {
            // на сервере в настройках не хранятся имена модулей и описание ивентов, нужно их получит
            // Приходит имя, а не id в мапе. нужно приводить к id transformFromModuleTypeStr
            const module = transformFromModuleTypeStr(setting.module ?? '');
            const curModule = enumsModule.moduleTypes.find((v: any) => v.value === module);
            const modelName = curModule?.description ?? setting.module;
            const eventDescription =
              eventTypes.data.find(event => setting.event === event.type)?.description ??
              setting.event;
            return {
              id: index,
              parent: this.parent,
              event: {
                type: setting.event,
                description: eventDescription,
              },
              module: {
                type: module,
                name: modelName,
              },
              timeout: setting.timeout,
            };
          })
        : [];
    }
  }

  get all() {
    return [...this.settings];
  }

  //получение create модели
  async create(): Promise<{data: CleanModuleSetting}> {
    const id = this.settings.length ? Math.max(...(this.settings.map(x => x.id) as [])) + 1 : 1;
    return {data: {id: id, parent: this.parent}};
  }

  //получение edit модели
  async edit(id: number): Promise<{data: CleanModuleSetting | null}> {
    const filteredModels = this.settings?.filter(x => x.id === id);

    let model: CleanModuleSetting | null = null;
    if (filteredModels?.length) model = {...filteredModels[0], parent: this.parent};
    return {data: model};
  }

  //сохранение
  async save(model: CleanModuleSetting) {
    if (this.settings) {
      const index = findIndex(this.settings, {id: model.id});
      if (index < 0) this.settings?.push(model);
      else this.settings?.splice(index, 1, model);
    }

    // убираем не нужные для сервера имена модулей и описание ивентов
    const str = JSON.stringify(
      this.settings.map(setting => ({
        timeout: setting.timeout,
        module: setting.module && setting.module.type ? PModuleType[setting.module.type] : '',
        event: setting.event?.type,
      })),
    );
    this.parent[this.settingName] = str;
    return {data: {success: true}};
  }

  //удаление
  async delete(id: number) {
    remove(this.settings as CleanModuleSetting[], (p: any) => p.id === id);
    this.parent[this.settingName] = JSON.stringify(
      this.settings.map(setting => ({
        timeout: setting.timeout,
        module: setting.module && setting.module.type ? PModuleType[setting.module.type] : '',
        event: setting.event?.type,
      })),
    );
    return {data: {success: true}};
  }
}
